/* ============================================================
   LEADS NOVA THEME — theme.js
   ============================================================ */

/* ---------- Mobile drawer ---------- */
function toggleDrawer(open){var d=document.getElementById('drawer');if(d)d.classList.toggle('open',open);}

/* ---------- Quantity stepper ---------- */
function qtyStep(delta){
  var inp=document.getElementById('qty');if(!inp)return;
  inp.value=Math.max(1,(parseInt(inp.value||1)+delta));
}

/* ---------- Gallery ---------- */
function pickThumb(btn,src){
  document.querySelectorAll('.thumbs button').forEach(function(b){b.classList.remove('on');});
  btn.classList.add('on');
  var main=document.getElementById('mainImg');
  if(main&&src)main.src=src;
}

/* ---------- Bundle visual select ---------- */
function pickBundle(el){
  document.querySelectorAll('.bundle').forEach(function(b){b.classList.remove('on');});
  el.classList.add('on');
}

/* ---------- Variant select: update price ---------- */
function initVariants(){
  var sel=document.getElementById('variant-select');
  if(!sel)return;
  var data=window.__variants||{};
  sel.addEventListener('change',function(){
    var v=data[sel.value];if(!v)return;
    var now=document.getElementById('price-now');
    var was=document.getElementById('price-was');
    var save=document.getElementById('price-save');
    if(now)now.textContent=v.price;
    if(was){ if(v.compare){was.textContent=v.compare;was.style.display='';}else{was.style.display='none';} }
    if(save){ if(v.savePct){save.textContent='SAVE '+v.savePct+'%';save.style.display='';}else{save.style.display='none';} }
  });
}

/* ---------- Countdown ---------- */
function startCountdown(){
  var el=document.getElementById('countdown');if(!el)return;
  var hrs=parseInt(el.getAttribute('data-hours')||8);
  var end=Date.now()+hrs*3600*1000;
  function tick(){
    var s=Math.max(0,Math.floor((end-Date.now())/1000));
    var h=String(Math.floor(s/3600)).padStart(2,'0');
    var m=String(Math.floor((s%3600)/60)).padStart(2,'0');
    var sec=String(s%60).padStart(2,'0');
    el.textContent=h+':'+m+':'+sec;
  }
  tick();setInterval(tick,1000);
}

/* ---------- Reveal on scroll ---------- */
function initReveal(){
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.1});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
}

/* ---------- Floating dotz ---------- */
function spawnDotz(host){
  var colors=['#cfe6f6','#c9ecd9','#f7d4ce','#fce7b8'];
  for(var i=0;i<7;i++){
    var d=document.createElement('span');d.className='dot';
    var size=20+Math.random()*60;
    d.style.setProperty('--c',colors[i%colors.length]);
    d.style.setProperty('--d',(7+Math.random()*6)+'s');
    d.style.width=d.style.height=size+'px';
    d.style.left=Math.random()*96+'%';d.style.top=Math.random()*90+'%';
    d.style.animationDelay=(Math.random()*4)+'s';
    host.appendChild(d);
  }
}

document.addEventListener('DOMContentLoaded',function(){
  initReveal();startCountdown();initVariants();
  document.querySelectorAll('.dotz').forEach(spawnDotz);
});
